
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { UniversalUserCard } from "@/components/common/UniversalUserCard";
import { useFriends } from "@/hooks/useFriends";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export const RequestsTab = () => {
  const { pendingRequests, loading, acceptFriendRequest, rejectFriendRequest } = useFriends();
  const { t } = useTranslation('friends');

  const handleAcceptRequest = async (friendshipId: string) => {
    const success = await acceptFriendRequest(friendshipId);
    if (success) {
      toast.success(t('requests.messages.accepted'));
    } else {
      toast.error(t('requests.messages.acceptError'));
    }
  };

  const handleRejectRequest = async (friendshipId: string) => {
    const success = await rejectFriendRequest(friendshipId);
    if (success) {
      toast.success(t('requests.messages.rejected'));
    } else {
      toast.error(t('requests.messages.rejectError'));
    }
  };

  return (
    <div className="space-y-4">
      {loading ? (
        <div className="flex justify-center py-8">
          <Loader2 className="h-6 w-6 animate-spin" />
        </div>
      ) : pendingRequests.length === 0 ? (
        <Card className="uplivion-card">
          <CardContent className="p-8 text-center">
            <p className="text-gray-500">{t('requests.empty')}</p>
          </CardContent>
        </Card>
      ) : (
        pendingRequests.map(request => (
          <UniversalUserCard 
            key={request.id} 
            user={request} 
            variant="request"
            onAccept={handleAcceptRequest}
            onReject={handleRejectRequest}
          />
        ))
      )}
    </div>
  );
};
